// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__X9vhG","showModal":"Modal_showModal__kobUJ","outer":"Modal_outer__em4tb","densed":"Modal_densed__IyZqd","close":"Modal_close__wkYj7"};